import React ,{useEffect} from "react";
import "./dropFiles.css"
// Icons 
import pictureFolder from "../../assets/Icons/pictureFolder.svg";
import { act } from "@testing-library/react";


export const DropFiles = () => {


    useEffect(()=>{
        document.addEventListener("DOMContentLoaded" , initAppDropArea);
    });


    const transHETo0 = () =>{
        const HeaderItemUFActive = document.querySelector("#HeaderItemUFActive");
        const InBDUF = document.querySelector("#InBDUF");

        HeaderItemUFActive.classList.remove("TransHeaderItemUFActive");
        InBDUF.classList.remove("InBDUFActive");

    }
    const transHETo100 = () =>{
        const HeaderItemUFActive = document.querySelector("#HeaderItemUFActive");
        const InBDUF = document.querySelector("#InBDUF");

        HeaderItemUFActive.classList.add("TransHeaderItemUFActive");
        InBDUF.classList.add("InBDUFActive");
    }


    
    const initAppDropArea = () => {
        const DropArea = document.getElementById("DropArea");

        const active = () => DropArea.classList.add("DropAreaActive");
        const inactive = () => DropArea.classList.remove("DropAreaActive");
        const prevents = (e) => e.preventDefault();

        ['dragenter' , 'dragover' , 'dragleave' , 'drop'].forEach(eventName =>{
            DropArea.addEventListener(eventName , prevents);
        });
        // Add Active
        ['dragenter' , 'dragover'].forEach(eventName =>{
            DropArea.addEventListener(eventName, active);
        });
        // Remove Acrive
        ['dragleave' , 'drop'].forEach(eventName =>{
            DropArea.addEventListener(eventName, inactive);
        });

        DropArea.addEventListener("drop" , handeleDrop);



    }

    const handeleDrop = (e) => {
        const data = e.dataTransfer;
        const file = data.files;
        const fileArray = [...file];
        console.log(fileArray);

        const reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () =>{
            console.log(reader.result);
        }

        const previewImage = document.getElementById("previewImage");
        previewImage.src = reader.result;
    }

    const preImg = () =>{
        const previewImage = document.getElementById("previewImage");
        const file = document.getElementById("avatar");
        previewImage.src = "https://cms-assets.tutsplus.com/cdn-cgi/image/width=360/uploads/users/1631/posts/29602/preview_image/react-crash-course.jpg";
    }



















    

    return(
        <div className="UploadFileContainer d-flex align-items-center justify-content-center" id="UploadFileContainer">
            <div className="BodyUploadFile">
                <div className="HeaderOfUF d-flex">
                    <div className="HeaderItemUF d-flex align-items-center justify-content-center" onClick={transHETo0}> <p className="LableUPHeaderElement">Upload File</p> </div>
                    <div className="HeaderItemUF d-flex align-items-center justify-content-center" onClick={transHETo100}> <p className="LableUPHeaderElement">Linke</p> </div>
                    <div className="HeaderItemUFActive" id="HeaderItemUFActive"></div>
                </div>

                <div className="BodyDropLink">
                    <div className="InBDUF d-flex" id="InBDUF">
                        <div className="BodyUpload d-flex align-items-center justify-content-center flex-column">
                            
                            <div className="DropArea d-flex align-items-center justify-content-center flex-column" id="DropArea">
                                <div> <img src={pictureFolder} className="pictureFolder" /> </div>
                                <div> <p className="LableDropI"> Drop Your Image here </p> </div>
                            </div>

                            { /*
                            <div className="showImagecOontainer">
                                <div className="previewImageContainer">
                                    <img className="previewImage"  id="previewImage" />
                                </div>
                            </div>
                            */ }

                            <div> <div className="ORBrowseBTN d-flex align-items-center justify-content-center"> <input type="file" id="avatar" name="avatar" accept="image/png, image/jpeg" onChange={preImg} /> Or Browse Files</div> </div>
                        </div>

                        <div className="BodyLink d-flex align-items-center justify-content-center flex-column">
                            <div className="asdwwwwwww d-flex align-items-center justify-content-center">
                                <p className="AddLinkLable">Add Link: </p>
                                <input type="text" id="LinkInputUF" placeholder="http://" />
                            </div>
                            <div className="UplodOkBTN d-flex align-items-center justify-content-center">Ok</div>
                        </div>
                         
                    </div>
                </div>
            </div>
        </div>
    )
}

